import { render, staticRenderFns } from "./allGoods.vue?vue&type=template&id=a881f06a&"
import script from "./allGoods.vue?vue&type=script&lang=js&"
export * from "./allGoods.vue?vue&type=script&lang=js&"
import style0 from "./allGoods.vue?vue&type=style&index=0&id=a881f06a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports